import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/auth.service';
import '../style/Login.css';
import logo from '../assets/sugbil-logo@240x240.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await AuthService.login(email, password).then(
        () => {
          navigate('/');
          window.location.reload();
        },
        (error) => {
          console.error(error);
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="login-card">
      <form onSubmit={handleLogin}>
        <img className="logo" src={logo} alt="" />
        <input
          className="inputs"
          type="text"
          placeholder="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="inputs"
          type="password"
          placeholder="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="btns" type="submit">
          Logga in
        </button>
      </form>
    </div>
  );
};

export default Login;
